module.exports = __webpack_public_path__ + "img/Attach.50558912.png";